var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button button--wide",class:{'button--primary': _vm.isPrimary},on:{"click":function($event){return _vm.openPage(_vm.link)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }